const doc = [({"en":({"js":({"admin":({"invoices":({"expandable_content":({"create_invoice_line":"Create invoice line"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;